import { memo, useMemo, type FC } from "react";
import { useTranslation } from "react-i18next";
import ChatChoiceStep from "./ChatChoiceStep";
import {
  WHATSAPP_MODES,
  WHATSAPP_MODE_QUESTION_KEY,
  getWhatsAppModeLabelKey,
} from "./ChatCampaignChoiceConstants";

interface ChatWhatsAppModeChoiceProps {
  onSelect: (_useAi: boolean) => void;
  isAnswered: boolean;
}

const ChatWhatsAppModeChoice: FC<ChatWhatsAppModeChoiceProps> = ({ onSelect, isAnswered }) => {
  const { t } = useTranslation();
  const options = useMemo(
    () => WHATSAPP_MODES.map(useAi => ({ value: useAi, label: t(getWhatsAppModeLabelKey(useAi)) })),
    [t]
  );

  return (
    <ChatChoiceStep
      question={t(WHATSAPP_MODE_QUESTION_KEY)}
      options={options}
      primaryValue
      onSelect={onSelect}
      isAnswered={isAnswered}
    />
  );
};

export default memo(ChatWhatsAppModeChoice);
